import { useEffect, useState } from "react";

const STORAGE_KEY = "language"; // npr. "sr", "en", "fr"...

export function useLanguage(defaultLang = "en") {
  const [language, setLanguage] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) || defaultLang;
    } catch {
      return defaultLang;
    }
  });

  // sync kad se menja u drugim tabovima
  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === STORAGE_KEY) {
        setLanguage(e.newValue || defaultLang);
      }
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, [defaultLang]);

  // helper ako ti treba da menjaš jezik i upisuješ u storage
  const updateLanguage = (lang) => {
    setLanguage(lang);
    try {
      localStorage.setItem(STORAGE_KEY, lang);
    } catch {}
  };

  return { language, updateLanguage };
}
